/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VoteResponse
 */
export interface VoteResponse {
    /**
     * 
     * @type {string}
     * @memberof VoteResponse
     */
    entryId: string;
    /**
     * 
     * @type {number}
     * @memberof VoteResponse
     */
    totalVotes?: number;
    /**
     * 
     * @type {number}
     * @memberof VoteResponse
     */
    voteCount?: number;
}

/**
 * Check if a given object implements the VoteResponse interface.
 */
export function instanceOfVoteResponse(value: object): value is VoteResponse {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    return true;
}

export function VoteResponseFromJSON(json: any): VoteResponse {
    return VoteResponseFromJSONTyped(json, false);
}

export function VoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'],
        'totalVotes': json['totalVotes'] == null ? undefined : json['totalVotes'],
        'voteCount': json['voteCount'] == null ? undefined : json['voteCount'],
    };
}

export function VoteResponseToJSON(json: any): VoteResponse {
    return VoteResponseToJSONTyped(json, false);
}

export function VoteResponseToJSONTyped(value?: VoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'totalVotes': value['totalVotes'],
        'voteCount': value['voteCount'],
    };
}

